export default __webpack_public_path__ + "static/media/create.0e5b8357.svg";